import React from 'react';
import moment from 'moment';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import { TableComponent, connect } from "./tableComponent";
import Sublogin from "./elements/sublogin"

class Component extends TableComponent {

  initialState = {
    from: moment().subtract(1, 'week'),
    to: moment().add(1, 'day'),
    type: "all",
    only_sales: true,
    expand: true,
    copied: false
  }

  getInitialState = (initialState)=> {
    if (this.props.user.role_id >= 3) {
      initialState.expand = false
      initialState.only_sales = true
      // initialState.from = moment().subtract(1, 'month')
      initialState.from = moment().isoWeekday(1);
    } else {
      initialState.expand = true
      initialState.only_sales = false
      initialState.from = moment().isoWeekday(1);
    }
    return initialState
  }

  makeColumns = () => {
    let columns = [
      {
        Header: "Wid",
        accessor: "aid",
        minWidth: 50,
        Footer: props => <span>Total</span>
      }, {
        Header: props => "Name / Reg date",
        accessor: "name",
        minWidth: 150,
        Cell: props => <div>{props.value} <br /> {moment(props.original.date*1000).format("D MMM YYYY")}</div>,
        Footer: props => <span>{this.props.total.count || 0}</span>
      }, {
        Header: props => "Email / Skype",
        accessor: "email",
        minWidth: 180,
        Cell: props => <div>{props.value} <br /> {props.original.skype != props.original.email ? props.original.skype : ""}</div>
      }, {
        Header: "Today",
        accessor: "today_sales",
        minWidth: 130,
        Cell: props => 
          <div>
            <div>{props.original.today_sales || 0} sales / $ {props.original.today_dollars || 0}</div>
            <div>{props.original.today_visits || 0} visits / {props.original.today_unique || 0} uniq</div>
          </div>,
        Footer: props => 
          <div>
            <div>$ {this.props.total.today_dollars || 0}</div>
            <div>{this.props.total.today_sales || 0} sales</div>
            <div>{this.props.total.today_visits || 0} visits</div>
            <div>{this.props.total.today_unique || 0} unique</div>
          </div>
      }, {
        Header: "Yesterday",
        accessor: "yesterday_sales",
        minWidth: 130,
        Cell: props => 
          <div>
            <div>{props.original.yesterday_sales || 0} sales / $ {props.original.yesterday_dollars || 0}</div>
            <div>{props.original.yesterday_visits || 0} visits / {props.original.yesterday_unique || 0} uniq</div>
          </div>,
        Footer: props => 
          <div>
            <div>$ {this.props.total.yesterday_dollars || 0}</div>
            <div>{this.props.total.yesterday_sales || 0} sales</div>
            <div>{this.props.total.yesterday_visits || 0} visits</div>
            <div>{this.props.total.yesterday_unique || 0} unique</div>
          </div>
      }, {
        Header: "Last week",
        accessor: "week_sales",
        minWidth: 150,
        Cell: props => 
          <div>
            <div>{props.original.week_sales || 0} sales / $ {props.original.week_dollars || 0}</div>
            <div>{props.original.week_visits || 0} visits / {props.original.week_unique || 0} uniq</div>
          </div>,
        Footer: props => 
          <div>
            <div>$ {this.props.total.week_dollars || 0}</div>
            <div>{this.props.total.week_sales || 0} sales</div>
            <div>{this.props.total.week_visits || 0} visits</div>
            <div>{this.props.total.week_unique || 0} unique</div>
          </div>
      }, {
        Header: props => this.props.state.from.format("D MMM")+" - "+this.props.state.to.format("D MMM"),
        accessor: "between_sales",
        minWidth: 150,
        Cell: props => 
          <div>
            <div>{props.original.between_sales || 0} sales / $ {props.original.between_dollars || 0}</div>
            <div>{props.original.between_visits || 0} visits / {props.original.between_unique || 0} uniq</div>
          </div>,
        Footer: props => 
          <div>
            <div>$ {this.props.total.between_dollars || 0}</div>
            <div>{this.props.total.between_sales || 0} sales</div>
            <div>{this.props.total.between_visits || 0} visits</div>
            <div>{this.props.total.between_unique || 0} unique</div>
          </div>
      }
    ]
    return columns; 
  }

  apiPath = "affiliate/invites"

  tableParams = {
    manual: true,
    sorted: [{
      id: "week_sales",
      desc: true
    }]    
  }

  render() {
    let link = location.protocol+"//"+location.host+"/app?mid="+this.props.user.aid
    return (
      <div class="co__pg-invites">
        {!this.props.state.initial &&         
        <div class="row">
          <div class="col-10 text-center co__table-filters">
            <div class="pull-left mr-2">
              {this.datepickerElement()}
            </div>

            <span class="pull-left p-2">Invite office:</span>
            <CopyToClipboard text={link} onCopy={() => this.setState({copied: link})}>
              <button class="btn primary pull-right">{this.state.copied == link ? "Copied" : "Copy"}</button>
            </CopyToClipboard>                                                 
            <pre class="overflow-hidden p-2 m-0">{link}</pre>   
          </div>
          <div class="col-2">{this.searchElement()}</div>
        </div>
        }
        <div class="row">
          <div class="col-sm-12">
            <div class="box mt-2">{this.reactTable()}</div>
          </div>
        </div>
      </div> 
    );
  }
}

export default connect(Component,"affiliate_invites")